var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useState } from 'react';
import { useDareAssignee } from 'root/src/client/logic/project/hooks/useDareAssignee';
import { usePreferredPlatform } from 'root/src/client/logic/dropEvent/hooks/usePreferredPlatform';
import { useUserHasGame } from 'root/src/client/v2/drop/hooks/useUserHasGame';
import { useModal } from 'root/src/client/v2/common/contexts/modal.context';
import { KeySelectionModal } from 'root/src/client/v2/drop/features/KeySelectionModal/components/KeySelectionModal';
import { Platform } from 'root/src/shared/@types/platforms';
import { useCreateProjectDropMutation } from 'root/src/client/v2/drop/hooks/useCreateProjectDropMutation';
import { InitialProductDisplayModal, } from 'root/src/client/v2/drop/features/KeySelectionModal/components/InitialProductDisplayModal';
import { useAppDispatch } from 'root/src/client/logic/helpers/useStore';
import { useDropShortUrl } from 'root/src/client/v2/drop/hooks/useDropShortUrl';
import { useLocalStorage } from 'root/src/client/web/hooks/useLocalStorage';
import { DARE_SUBMISSION_MODAL_MODULE_ID } from 'root/src/shared/descriptions/modules/moduleIds';
import displayModal from 'root/src/client/logic/modal/thunks/displayModal';
import { PreferredPlatformReachedMaxDaresModal, } from 'root/src/client/v2/creator/components/PreferredPlatformReachedMaxDaresModal';
import toast from 'react-hot-toast';
import { useIsAuthenticated } from 'root/src/client/v2/auth/hooks/useIsAuthenticated';
import { useMaxDaresByPlatforms } from 'root/src/client/logic/dropEvent/hooks/useMaxDaresByPlatforms';
import { useIsAdmin } from 'root/src/client/v2/auth/hooks/useIsAdmin';
import { useIsBrand } from 'root/src/client/v2/auth/hooks/useIsBrand';
import { isDropComingSoon } from 'root/src/shared/drops/helpers/isDropComingSoon.helper';
import { ProjectStatus } from 'root/src/shared/@types/project';
import { redirectToCreateBrandProjectForm, } from 'root/src/client/logic/dropEvent/thunks/redirectToCreateBrandProjectForm';
import { isDareAnyPlatform } from 'root/src/shared/drops/helpers/dropDare.helpers';
import SignInWithProviderModal from 'root/src/client/web/auth/features/SignInWithProviderModal';
import { CompletionType } from 'root/src/shared/rewards/constants';
import { ModalLayout } from 'root/src/client/v2/common/layouts/ModalLayout';
import { Provider } from 'root/src/shared/@types/providers';
import { ScopeSet } from 'root/src/shared/@types/auth';
import { trpc } from 'root/src/client/v2/trpc/trpc';
import { UpgradePermissionsModal } from 'root/src/client/v2/auth/components/UpgradePermissionsModal';
const ManualModeDescription = () => {
    return (<div>
			<p className="text-sm">We will select randomly a one or more of your viewers to receive a reward, and we'll send you an email with instructions on how to do that and who won.</p>
		</div>);
};
const AutoModeDescription = () => {
    return (<div>
			<p className="text-sm">This Dare will be automatically completed once you fulfil description requirements.</p>
			<p className="text-sm">Your viewers will have chance to win a reward as a result of this Dare.</p>
			<p className="text-sm">To be able to accept this Dare, you need to give us permission to access your Twitch account.</p>
			<p className="text-sm">We will select randomly a one or more of your viewers to receive a reward, and announce them in your chat.</p>
		</div>);
};
const GameIntegratedPermissionModal = ({ onContinue }) => {
    return (<UpgradePermissionsModal autoLabel="I want to automatically announce winners in my chat (Recommended)" manualLabel="I will announce winners on my own (Not recommended)" renderDescription={isAutoModeEnabled => (isAutoModeEnabled ? <AutoModeDescription /> : <ManualModeDescription />)} scopeSet={ScopeSet.creatorPlus} provider={Provider.Twitch} onContinue={onContinue}/>);
};
export const useAcceptDare = ({ drop, dare, refetchDropEvent }) => {
    var _a, _b;
    const [showSubmissionModal] = useLocalStorage('showSubmissionModal', true);
    const [showPlatformAdjustedModal] = useLocalStorage('showPlatformAdjustedModal', true);
    const [submitting, setSubmitting] = useState(false);
    const utils = trpc.useUtils();
    const modal = useModal();
    const { isAdmin } = useIsAdmin();
    const { isBrand } = useIsBrand();
    const isAdminOrBrand = isAdmin || isBrand;
    const assignee = useDareAssignee({ dare, fallbackDrop: drop });
    const preferredPlatform = usePreferredPlatform();
    const isAuthenticated = useIsAuthenticated();
    const brandId = (_b = (_a = drop === null || drop === void 0 ? void 0 : drop.brand) === null || _a === void 0 ? void 0 : _a.id) !== null && _b !== void 0 ? _b : drop === null || drop === void 0 ? void 0 : drop.brandId;
    const userHasGameQuery = useUserHasGame({ dropId: drop === null || drop === void 0 ? void 0 : drop.id, brandId }, false);
    const shortUrlQuery = useDropShortUrl({ dropId: drop === null || drop === void 0 ? void 0 : drop.id, enabled: false });
    const createProjectDropMutation = useCreateProjectDropMutation();
    const creatorCanAccept = useCreatorCanAccept(drop);
    const initialProduct = (drop === null || drop === void 0 ? void 0 : drop.initialProduct) || [];
    const displayPreferredPlatformReachedMaxDaresModal = usePreferredPlatformReachedMaxDaresModal();
    const displaySubmissionPlatformModal = useSubmissionPlatformModal();
    const redirectToCreatProjectForm = useRedirectToCreateProject();
    const comingSoon = isDropComingSoon(drop);
    const reacceptProjectMutation = trpc.project.reacceptProject.useMutation();
    const onAcceptDare = ({ setHover = defaultSetHover, onSuccess } = {}) => __awaiter(void 0, void 0, void 0, function* () {
        var _c;
        if (!isAuthenticated) {
            return;
        }
        if (isAdminOrBrand) {
            redirectToCreatProjectForm({
                id: dare.id,
                title: dare.title,
                description: dare.description,
                paymentInfo: dare.paymentInfo,
                campaign: { name: drop.campaignName, campaignId: drop.id },
            });
            return;
        }
        if (!creatorCanAccept || !assignee || comingSoon) {
            return;
        }
        if (submitting) {
            return;
        }
        const isAnyPlatformDare = isDareAnyPlatform(dare);
        const isGameIntegratedDare = ((_c = dare.completion) === null || _c === void 0 ? void 0 : _c.type) === CompletionType.GAME_INTEGRATED;
        if (isGameIntegratedDare) {
            const canAcceptGameIntegratedDare = yield utils.dares.getCanAcceptGameIntegratedDare.fetch({
                platform: Platform.Twitch,
            });
            if (!canAcceptGameIntegratedDare) {
                modal.show(<ModalLayout>
						<SignInWithProviderModal props={{
                        item: {
                            provider: Provider.Twitch,
                            header: 'Sign in to continue',
                            label: 'Please re-authenticate your Twitch account to accept this Dare.',
                        },
                    }}/>
					</ModalLayout>);
                return;
            }
            const hasValidToken = yield utils.auth.hasValidTokenScope.fetch({
                platform: Platform.Twitch,
                scopeSet: ScopeSet.creatorPlus,
            });
            if (!hasValidToken) {
                const shouldContinueWithoutPermissions = yield new Promise(resolve => modal.show(<GameIntegratedPermissionModal onContinue={() => resolve(true)}/>, {
                    onClose: () => resolve(false),
                }));
                if (!shouldContinueWithoutPermissions) {
                    return;
                }
            }
        }
        const isPreferredPlatformReachedMaxDaresModalVisible = isAnyPlatformDare
            && showPlatformAdjustedModal
            && preferredPlatform
            && preferredPlatform !== assignee.platform;
        const isPlatformSubmissionModalVisible = isAnyPlatformDare
            && showSubmissionModal;
        if (isPreferredPlatformReachedMaxDaresModalVisible) {
            const isAccepted = yield displayPreferredPlatformReachedMaxDaresModal(assignee.platform);
            if (!isAccepted) {
                return;
            }
        }
        if (isPlatformSubmissionModalVisible) {
            const isAccepted = yield displaySubmissionPlatformModal();
            if (!isAccepted) {
                return;
            }
        }
        const createProjectPayload = {
            dropDareId: dare.id,
            paymentInfo: dare.paymentInfo,
            assignees: [assignee],
            dropEvent: drop,
            userHasGame: false,
        };
        const { data: userHasGame = false } = yield userHasGameQuery.refetch();
        if (!userHasGame) {
            if (initialProduct.length) {
                modal.show(<KeySelectionModal dropEvent={drop} payload={createProjectPayload} dare={dare}/>);
                return;
            }
        }
        const showSuccessModal = () => __awaiter(void 0, void 0, void 0, function* () {
            if ((userHasGame && (drop.isGameFree || !initialProduct))) {
                const shortUrl = yield shortUrlQuery.refetch();
                return modal.show(<InitialProductDisplayModal dropEvent={drop} dare={dare} shortUrl={shortUrl.data}/>, {
                    isCloseable: false,
                });
            }
            return null;
        });
        setSubmitting(true);
        setHover(true);
        try {
            if (dare.status === ProjectStatus.Rejected) {
                yield reacceptProjectMutation.mutateAsync({
                    dropDareId: dare.id,
                    assignee: {
                        platformId: assignee.id,
                        platform: assignee.platform,
                    },
                });
            }
            else {
                yield createProjectDropMutation.mutateAsync(Object.assign(Object.assign({}, createProjectPayload), { userHasGame,
                    showSuccessModal,
                    onSuccess }));
            }
            if (refetchDropEvent) {
                void refetchDropEvent();
            }
            setSubmitting(false);
            setHover(false);
        }
        catch (error) {
            console.error(error);
            toast.error(error.error);
        }
        setSubmitting(false);
        setHover(false);
    });
    return { onAcceptDare };
};
const usePreferredPlatformReachedMaxDaresModal = () => {
    const modal = useModal();
    return (targetPlatform) => new Promise((resolve) => {
        return modal.show(<PreferredPlatformReachedMaxDaresModal platform={targetPlatform} onClose={() => {
                modal.hide();
                resolve(false);
            }} onSubmit={() => {
                modal.hide();
                resolve(true);
            }}/>, {
            isCloseable: false,
        });
    });
};
const useSubmissionPlatformModal = () => {
    const dispatch = useAppDispatch();
    return () => new Promise((resolve) => {
        dispatch(displayModal(DARE_SUBMISSION_MODAL_MODULE_ID, {
            onCancel: () => {
                displayModal(undefined);
                resolve(false);
            },
            onAccept: () => __awaiter(void 0, void 0, void 0, function* () {
                // !!!! This displayModal(undefined) is important.
                // !!!! Otherwise, we're not closing modal properly, leading to creating duplicate dares.
                displayModal(undefined);
                resolve(true);
            }),
            onClose: () => {
                displayModal(undefined);
                resolve(false);
            },
        }));
    });
};
const useCreatorCanAccept = (drop) => {
    const maxDares = useMaxDaresByPlatforms({ fallbackDrop: drop });
    const { isBrand } = useIsBrand();
    const { isAdmin } = useIsAdmin();
    return !isAdmin && !isBrand && maxDares > 0;
};
const defaultSetHover = () => null;
const useRedirectToCreateProject = () => {
    const dispatch = useAppDispatch();
    return (params) => {
        dispatch(redirectToCreateBrandProjectForm(params));
    };
};
